export var BackgroundBackground = '#ffffff';
export var SurfaceSurface = '#ffffff';
export var SurfaceSurfaceHover = '#f4f4f4';
export var SurfaceSurfaceSecondary = '#fbfbfb';
export var SurfaceSurfaceTertiary = '#e8e8e8';
export var SurfaceSurfaceQuaternary = '#d3d3d3';
export var SurfaceSurfaceSecondaryHover = '#f4f4f4';
export var SurfaceSurfaceSecondaryFocus = '#fbfbfb';
export var SurfaceCardSurface = '#ffffff';
export var SurfaceCardSurfaceHover = '#ffffff';
export var SurfaceCardSurfaceFocus = '#f2f7fd';
export var SurfaceCardSurfacePressed = '#fbfbfb';
export var SurfaceMenuSurface = '#ffffff';
export var SurfaceMenuSurfaceHover = '#f4f4f4';
export var SurfaceMenuSurfacePressed = '#f4f4f4';
export var SurfaceMenuSurfaceFocus = '#f4f4f4';
export var SurfaceSurfaceBrand = '#0061D5';
export var SurfaceSurfaceBrandHover = '#006AE9';
export var SurfaceSurfaceBrandPressed = '#004EAC';
export var SurfaceSurfaceBrandSecondary = '#e5effa';
export var SurfaceSurfaceBrandBusy = '#0061D5';
export var SurfaceSurfaceBrandDisabled = '#0061D5';
export var SurfaceCtaSurfaceSecondary = '#ffffff';
export var SurfaceCtaSurfaceSecondaryBusy = '#ffffff';
export var SurfaceCtaSurfaceSecondaryDisabled = '#ffffff';
export var SurfaceCtaSurfaceSecondaryHover = '#f4f4f4';
export var SurfaceCtaSurfaceSecondaryFocus = '#f4f4f4';
export var SurfaceCtaSurfaceSecondaryPressed = '#e8e8e8';
export var SurfaceCtaSurfaceSecondaryFocusPressed = '#e8e8e8';
export var SurfaceDropdownSurface = '#ffffff';
export var SurfaceDropdownSurfaceHover = '#ffffff';
export var SurfaceDropdownSurfaceFocus = '#ffffff';
export var SurfaceDropdownSurfaceError = '#ffffff';
export var SurfaceDropdownSurfaceErrorHover = '#ffffff';
export var SurfaceDropdownSurfaceErrorFocus = '#ffffff';
export var SurfaceInputSurface = '#ffffff';
export var SurfaceInputSurfaceHover = '#ffffff';
export var SurfaceInputSurfaceFocus = '#ffffff';
export var SurfaceInputSurfaceError = '#ffffff';
export var SurfaceInputSurfaceErrorHover = '#ffffff';
export var SurfaceInputSurfaceErrorFocus = '#ffffff';
export var SurfaceToggleSurfaceOffHover = '#f4f4f4';
export var SurfaceToggleSurfaceOn = '#e5effa';
export var SurfaceToggleSurfaceOnHover = '#ccdff7';
export var SurfaceMessageSurfaceWarning = '#fdf0d1';
export var SurfaceMessageSurfaceWarningSecondary = '#fef7e8';
export var SurfaceMessageSurfaceError = '#fbd7dd';
export var SurfaceMessageSurfaceErrorSecondary = '#fdebee';
export var SurfaceTooltipSurface = '#4e4e4e';
export var SurfaceTooltipSurfaceError = '#fdebee';
export var SurfaceMessageSurfaceGeneric = '#e8e8e8';
export var SurfaceMessageSurfaceGenericSecondary = '#e8e8e8';
export var SurfaceMessageSurfaceInfo = '#d3e7fe';
export var SurfaceMessageSurfaceInfoSecondary = '#e9f2fe';
export var SurfaceMessageSurfaceSuccess = '#d4f3e6';
export var SurfaceMessageSurfaceSuccessSecondary = '#e9f8f2';
export var SurfaceMessageSurfacePromoSecondary = '#ece9f8';
export var SurfacePillSurface = '#e8e8e8';
export var SurfacePillSurfaceHover = '#e8e8e8';
export var SurfacePillSurfaceFocus = '#e8e8e8';
export var SurfaceFilterSurface = '#0061d5';
export var SurfaceFilterSurfaceHover = '#0061d5';
export var SurfaceFilterSurfaceFocus = '#0061d5';
export var SurfaceFilterSurfaceSelected = '#0061d5';
export var SurfaceFilterSurfaceSelectedFocus = '#0061d5';
export var SurfaceStatusSurfaceGeneric = '#a7a7a7';
export var SurfaceStatusSurfaceSuccess = '#26c281';
export var SurfaceStatusSurfaceError = '#ed3757';
export var SurfaceStatusSurfacePending = '#a7a7a7';
export var SurfaceStatusSurfaceScheduled = '#9f3fed';
export var SurfaceStatusSurfaceUploading = '#0061d5';
export var SurfaceStatusSurfaceInprogress = '#f5b31b';
export var SurfaceCtaSurfaceOutline = 'rgba(0,0,0,0)';
export var SurfaceCtaSurfaceOutlineHover = 'rgba(0,0,0,0.04)';
export var SurfaceCtaSurfaceOutlinePressed = 'rgba(0,0,0,0.08)';
export var SurfaceCtaSurfaceIcon = 'rgba(0,0,0,0)';
export var SurfaceCtaSurfaceIconDisabled = 'rgba(0,0,0,0)';
export var SurfaceCtaSurfaceIconHover = 'rgba(0,0,0,0.04)';
export var SurfaceCtaSurfaceIconPressed = 'rgba(0,0,0,0.08)';
export var SurfaceCtaSurfaceIconUtility = '#e8e8e8';
export var SurfaceCtaSurfaceIconUtilityHover = '#d3d3d3';
export var SurfaceCtaSurfaceIconUtilityPressed = '#bcbcbc';
export var SurfaceCtaSurfaceTertiary = '#ffffff';
export var SurfaceCtaSurfaceTertiaryHover = '#f4f4f4';
export var SurfaceCtaSurfaceTertiaryPressed = '#e8e8e8';
export var SurfaceCtaSurfaceTertiaryPromo = '#ece9f8';
export var SurfaceCtaSurfaceTertiaryPromoHover = '#f6f4fc';
export var SurfaceCtaSurfaceTertiaryPromoPressed = '#dad4f3';
export var SurfaceCtaSurfaceTertiaryPromoFocus = '#f6f4fc';
export var SurfaceCtaSurfaceTertiaryPromoFocusPressed = '#dad4f3';
export var SurfaceStatusSurfaceYellow = '#ffeb7f';
export var SurfaceStatusSurfaceYellowHover = '#ffeb7f';
export var SurfaceStatusSurfaceYellowFocus = '#ffeb7f';
export var SurfaceStatusSurfaceOrange = '#f8c08c';
export var SurfaceStatusSurfaceOrangeHover = '#f8c08c';
export var SurfaceStatusSurfaceOrangeFocus = '#f8c08c';
export var SurfaceStatusSurfaceRed = '#f69bab';
export var SurfaceStatusSurfaceRedHover = '#f69bab';
export var SurfaceStatusSurfaceRedFocus = '#f69bab';
export var SurfaceStatusSurfacePurple = '#cf9ff6';
export var SurfaceStatusSurfacePurpleHover = '#cf9ff6';
export var SurfaceStatusSurfacePurpleFocus = '#cf9ff6';
export var SurfaceStatusSurfaceLightBlue = '#91c2fd';
export var SurfaceStatusSurfaceLightBlueHover = '#91c2fd';
export var SurfaceStatusSurfaceLightBlueFocus = '#91c2fd';
export var SurfaceStatusSurfaceDarkBlue = '#7f9dc1';
export var SurfaceStatusSurfaceDarkBlueHover = '#7f9dc1';
export var SurfaceStatusSurfaceDarkBlueFocus = '#7f9dc1';
export var SurfaceStatusSurfaceGreen = '#92e0c0';
export var SurfaceStatusSurfaceGreenHover = '#92e0c0';
export var SurfaceStatusSurfaceGreenFocus = '#92e0c0';
export var SurfaceStatusSurfaceBoxblue = '#0061d5';
export var SurfaceStatusSurfaceBoxblueHover = '#0061d5';
export var SurfaceStatusSurfaceBoxblueFocus = '#0061d5';
export var SurfaceStatusSurfaceGray = '#e8e8e8';
export var SurfaceStatusSurfaceGrayHover = '#e8e8e8';
export var SurfaceStatusSurfaceGrayFocus = '#e8e8e8';
export var SurfaceItemSurfaceHover = '#ffffff';
export var SurfaceItemSurfaceSelected = '#f2f7fd';
export var SurfaceItemSmallSurface = '#ffffff';
export var SurfaceItemSmallSurfaceHover = '#f4f4f4';
export var SurfaceItemSmallSurfaceSelected = '#f2f7fd';
export var SurfaceSwitchSurface = '#ffffff';
export var SurfaceSwitchSurfaceHover = '#ffffff';
export var SurfaceSwitchSurfaceOff = '#d3d3d3';
export var SurfaceSwitchSurfaceOffHover = '#bcbcbc';
export var SurfaceSwitchSurfaceOn = '#0061d5';
export var SurfaceSwitchSurfaceOnHover = '#2079E3';
export var SurfaceRadioSurface = '#ffffff';
export var SurfaceRadioSurfaceHover = '#ffffff';
export var SurfaceRadioSurfaceSelected = '#0061d5';
export var SurfaceRadioSurfaceSelectedHover = '#2079E3';
export var SurfaceCheckboxSurface = '#ffffff';
export var SurfaceCheckboxSurfaceHover = '#ffffff';
export var SurfaceCheckboxSurfaceSelected = '#0061d5';
export var SurfaceCheckboxSurfaceSelectedHover = '#2079E3';
export var SurfaceGhostSurface = '#fbfbfb';
export var SurfaceGhostSurfaceSecondary = '#f4f4f4';
export var SurfaceInputchipSurface = '#e8e8e8';
export var SurfaceInputchipSurfaceHover = '#e8e8e8';
export var SurfaceInputchipSurfaceError = '#fdebee';
export var SurfaceFilterchipSurfaceMulti = 'rgba(0,0,0,0.04)';
export var SurfaceFilterchipSurfaceMultiHover = 'rgba(0,0,0,0.08)';
export var SurfaceFilterchipSurfaceMultiOn = '#e5effa';
export var SurfaceFilterchipSurfaceMultiOnHover = '#ccdff7';
export var SurfaceFilterchipSurfaceSingle = 'rgba(0,0,0,0.04)';
export var SurfaceFilterchipSurfaceSingleHover = 'rgba(0,0,0,0.08)';
export var SurfaceFilterchipSurfaceSingleOn = '#0061d5';
export var SurfaceFilterchipSurfaceSingleOnHover = '#0061d5';
export var SurfaceSlidertrackSurface = '#6F6F6F';
export var SurfaceSliderthumbSurface = '#0061d5';
export var SurfaceSliderthumbSurfaceHover = '#2486fc';
export var SurfaceScrollbarSurface = 'rgba(0,0,0,0.5)';
export var SurfaceSearchSurface = '#f4f4f4';
export var SurfaceSearchGlobalSurface = '#f4f4f4';
export var SurfaceSearchSurfaceHover = '#fbfbfb';
export var SurfaceSearchSurfaceFocused = '#ffffff';
export var SurfaceDaySurface = '#ffffff';
export var SurfaceDaySurfaceHover = '#f4f4f4';
export var SurfaceDaySurfaceSelected = '#0061d5';
export var SurfaceDaySurfaceSelectedHover = '#003c84';
export var SurfaceTabSurfaceHover = '#f4f4f4';
export var SurfaceTabSurfacePressed = '#e8e8e8';
export var SurfaceAccordionSurface = '#ffffff';
export var SurfaceAccordionSurfaceHover = '#f4f4f4';
export var SurfaceBadgeImageSurface = '#26c281';
export var SurfaceBadgeCanvasSurface = '#f1811a';
export var SurfaceBadgeBoxnoteSurface = '#e8e8e8';
export var SurfaceBadgeFolderexternalSurface = '#6F6F6F';
export var SurfaceBadgeFoldersharedSurface = '#2486fc';
export var SurfaceBadgeRelaySurface = '#1d6bca';
export var SurfaceBadgeMentionSurface = '#1d6bca';
export var SurfaceBadgeTaskSurface = '#2486fc';
export var SurfaceBadgeTaskapprovalSurface = '#1d6bca';
export var SurfaceBadgeAnnotationSurface = '#f5b31b';
export var SurfaceBadgeCompletedSurface = '#26c281';
export var SurfaceBadgeRejectedSurface = '#D5324E';
export var SurfaceBadgeErrorSurface = '#D5324E';
export var SurfaceBadgeExternalSurface = '#909090';
export var SurfaceBadgeAdminSurface = '#003c84';
export var SurfaceBadgeCoadminSurface = '#9f3fed';
export var SurfaceBadgeOnlineSurface = '#1e9b67';
export var SurfaceBadgePinSurface = '#e8e8e8';
export var SurfaceBadgeCollectionSurface = '#e8e8e8';
export var SurfaceBadgeOfflineSurface = '#26c281';
export var SurfaceBadgeProgressSurface = '#f5b31b';
export var SurfaceBadgeNotificationSurface = '#D5324E';
export var SurfaceBadgePdfSurface = '#D0021B';
export var SurfaceBadgeDocsSurface = '#4083F7';
export var SurfaceBadgeSheetsSurface = '#21A464';
export var SurfaceBadgePagesSurface = '#FF9500';
export var SurfaceBadgeKeynoteSurface = '#0A84FF';
export var SurfaceBadgeVideoSurface = '#009AED';
export var SurfaceChipButtonSurface = 'rgba(0,0,0,0.04)';
export var SurfaceChipButtonSurfaceHover = 'rgba(0,0,0,0.08)';
export var SurfacePageSurface = '#ffffff';
export var SurfaceOptionGridSurfaceHover = 'rgba(0,0,0,0.04)';
export var SurfaceOptionGridSurfaceSelected = 'rgba(0,0,0,0.08)';
export var SurfaceDropdownPrimarySurfaceHover = '#f4f4f4';
export var SurfaceDropdownPrimarySurfacePressed = '#e8e8e8';
export var SurfaceDropdownSecondarySurface = '#ffffff';
export var SurfaceDropdownSecondarySurfaceHover = '#f4f4f4';
export var SurfaceDropdownSecondarySurfacePressed = '#e8e8e8';
export var SurfaceToggleSurface = '#ffffff';
export var SurfaceToggleSurfaceHover = '#f4f4f4';
export var SurfaceToggleSurfacePressed = '#0061d5';
export var SurfaceToggleSurfacePressedHover = '#3381dd';
export var SurfaceTextHighlightSurface = '#fff7cc';
export var SurfaceNavSurfaceBrand = '#0061d5';
export var SurfaceProgressbarSurfaceBrand = '#0061d5';
export var SurfaceIllustrationSurfaceBoxNeutral = '#0061d5';
export var SurfaceIllustrationSurfaceBox = '#0061d5';
export var SurfaceUploadSurfaceBrandNeutral = '#0061d5';
export var SurfaceCtaSurfacePromo = '#4122AF';
export var SurfaceCtaSurfacePromoHover = '#4826c2';
export var SurfaceCtaSurfacePromoPressed = '#3a1e9b';
export var SurfaceCtaSurfacePromoFocus = '#4826c2';
export var SurfaceCtaSurfacePromoFocusPressed = '#3a1e9b';
export var SurfaceContentbuttonSurfaceSurfaceSelected = '#ffffff';
export var SurfaceContentswitcherSurface = '#e8e8e8';
export var SurfaceToolbarSurface = '#222222';
export var SurfaceToggleSurfaceOffPressed = '#e8e8e8';
export var SurfaceToggleSurfaceOnPressed = '#b2cff2';
export var SurfaceCtaSurfaceDisabled = '#b2cff2';
export var SurfaceRadiotileSurface = '#ffffff';
export var SurfaceRadiotileSurfaceHover = '#f4f4f4';
export var SurfaceRadiotileSurfaceSelected = '#f2f7fd';
export var SurfaceToggletextSurfaceOn = '#e5effa';
export var SurfaceToggletextSurfaceOnHover = '#ccdff7';
export var SurfaceToggletextSurfaceOnPressed = '#b2cff2';
export var SurfaceToggletextSurfaceOnAi = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var SurfaceToggletextSurfaceOnAiHover = 'linear-gradient(135deg, #CB02B0 0%, #1F6AC8 100%)';
export var SurfaceToggletextSurfaceOnAiPressed = 'linear-gradient(135deg, #980284 0%, #174F96 100%)';
export var SurfaceToggletextSurfaceOffAi = '#ffffff';
export var SurfaceToggletextSurfaceOffAiHover = '#f4f4f4';
export var SurfaceToggletextSurfaceOffAiPressed = '#e8e8e8';
export var BorderCtaBorderSecondary = '#bcbcbc';
export var BorderCtaBorderSecondaryPressed = '#bcbcbc';
export var BorderCtaBorderSecondaryHover = '#bcbcbc';
export var BorderCardBorder = '#e8e8e8';
export var BorderCardBorderHover = '#e8e8e8';
export var BorderCardBorderFocus = '#0061d5';
export var BorderMessageBorderGeneric = '#222222';
export var BorderMessageBorderGenericSecondary = '#909090';
export var BorderMessageBorderInfo = '#0061d5';
export var BorderMessageBorderInfoSecondary = '#91c2fd';
export var BorderMessageBorderSuccess = '#26c281';
export var BorderMessageBorderSuccessSecondary = '#92e0c0';
export var BorderMessageBorderWarning = '#f5b31b';
export var BorderMessageBorderWarningSecondary = '#fad98d';
export var BorderMessageBorderError = '#ed3757';
export var BorderMessageBorderErrorSecondary = '#f69bab';
export var BorderInputBorder = '#909090';
export var BorderInputBorderHover = '#6F6F6F';
export var BorderInputBorderFocus = '#2486fc';
export var BorderInputBorderError = '#ed3757';
export var BorderInputBorderErrorHover = '#ed3757';
export var BorderInputBorderErrorFocus = '#ed3757';
export var BorderDropdownBorder = '#bcbcbc';
export var BorderDropdownBorderHover = '#6F6F6F';
export var BorderDropdownBorderFocus = '#0061d5';
export var BorderDropdownBorderError = '#ed3757';
export var BorderDropdownBorderErrorHover = '#ed3757';
export var BorderDropdownBorderErrorFocus = '#ed3757';
export var BorderTooltipBorderError = '#f69bab';
export var BorderTabBorderSelected = '#0061d5';
export var BorderTabBorderSelectedHover = '#0061d5';
export var BorderTabBorderSelectedFocus = '#0061d5';
export var BorderTabBorder = '#e8e8e8';
export var BorderTabBorderHover = '#bcbcbc';
export var BorderCtaBorderOutline = '#000000';
export var BorderCtaBorderOutlineHover = '#000000';
export var BorderCtaBorderOutlinePressed = '#000000';
export var BorderItemBorderHover = '#e8e8e8';
export var BorderItemBorderSelected = '#0061d5';
export var BorderItemSmallBorderSelected = '#0061d5';
export var BorderSwitchBorder = '#bcbcbc';
export var BorderSwitchBorderHover = '#bcbcbc';
export var BorderRadioBorder = '#6F6F6F';
export var BorderRadioBorderSelected = '#0061d5';
export var BorderRadioBorderSelectedHover = '#2079E3';
export var BorderRadioBorderHover = '#4e4e4e';
export var BorderCheckboxBorder = '#6F6F6F';
export var BorderCheckboxBorderHover = '#4e4e4e';
export var BorderCheckboxBorderSelected = '#0061d5';
export var BorderCheckboxBorderSelectedHover = '#2079E3';
export var BorderDividerBorder = '#e8e8e8';
export var BorderCardBorderPressed = '#e8e8e8';
export var BorderInputchipBorderError = '#ed3757';
export var BorderAvatarBorderHover = 'rgba(0,0,0,0.04)';
export var BorderAvatarBorderPressed = 'rgba(0,0,0,0.08)';
export var BorderStatusBorderHover = 'rgba(0,0,0,0.04)';
export var BorderSearchBorder = '#f4f4f4';
export var BorderSearchBorderHover = '#6F6F6F';
export var BorderSearchGlobalBorderHover = '#e8e8e8';
export var BorderGridthumbnailBorder = '#e8e8e8';
export var BorderFilterchipBorderMultiOn = '#99c0ee';
export var BorderFilterchipBorderMultiOnHover = '#99c0ee';
export var BorderCollapsibleBorder = '#d3d3d3';
export var BorderBadgeBorder = '#ffffff';
export var BorderToggleBorder = '#bcbcbc';
export var BorderCardBorderAi = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderCtaBorderAi = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderContentbuttonBorderSelected = '#909090';
export var BorderToggleBorderOn = '#99c0ee';
export var BorderCtaBorderSecondaryDisabled = '#e8e8e8';
export var BorderCtaBorderOutlineDisabled = '#646464';
export var BorderRadiotileBorder = '#bcbcbc';
export var BorderRadiotileBorderHover = '#bcbcbc';
export var BorderRadiotileBorderSelected = '#0061d5';
export var BorderToggletextBorderOff = '#ffffff';
export var BorderToggletextBorderOffHover = '#f4f4f4';
export var BorderToggletextBorderOffPressed = '#e8e8e8';
export var BorderToggletextBorderOn = '#99c0ee';
export var BorderToggletextBorderOnHover = '#99c0ee';
export var BorderToggletextBorderOnPressed = '#99c0ee';
export var BorderToggletextBorderOnAi = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderToggletextBorderOnAiHover = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderToggletextBorderOnAiPressed = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderToggletextBorderOffAi = '#bcbcbc';
export var BorderToggletextBorderOffAiHover = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderToggletextBorderOffAiPressed = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BorderDividerBorderBrand = '#e8e8e8';
export var IconIconOnLight = '#222222';
export var IconIconOnLightSecondary = '#6F6F6F';
export var IconIconOnLightTertiary = '#909090';
export var IconIconOnDark = '#ffffff';
export var IconIconErrorOnLight = '#D5324E';
export var IconIconRequiredOnLight = '#D5324E';
export var IconNavIconOnDark = '#ffffff';
export var IconNavIconOnDarkHover = '#ffffff';
export var IconNavIconOnDarkSelected = '#ffffff';
export var IconNavIconOnDarkFocus = '#ffffff';
export var IconNavIconOnLight = '#222222';
export var IconNavIconOnLightHover = '#222222';
export var IconNavIconOnLightSelected = '#222222';
export var IconNavIconOnLightFocus = '#222222';
export var IconCtaIcon = '#6F6F6F';
export var IconCtaIconHover = '#222222';
export var IconCtaIconPressed = '#222222';
export var IconCtaIconUtility = '#4e4e4e';
export var IconCtaIconUtilityHover = '#000000';
export var IconCtaIconUtilityPressed = '#000000';
export var IconCtaIconOnColor = '#000000';
export var IconCtaIconOnColorHover = '#000000';
export var IconCtaIconOnColorPressed = '#000000';
export var IconIconBlue = '#0061d5';
export var IconIconDestructiveOnLight = '#D5324E';
export var OutlineFocusOnLight = '#2486fc';
export var OutlineFocusOnDark = '#ffffff';
export var TextTextOnLight = '#222222';
export var TextTextOnLightSecondary = '#6F6F6F';
export var TextTextOnLightTertiary = '#909090';
export var TextTextOnLightSecondaryHover = '#4e4e4e';
export var TextTextOnDark = '#ffffff';
export var TextTextBrandOnColor = '#ffffff';
export var TextCtaLink = '#0061d5';
export var TextCtaLinkHover = '#1d6bca';
export var TextCtaLinkPressed = '#2486fc';
export var TextNavTextOnDark = '#ffffff';
export var TextNavTextOnDarkHover = '#ffffff';
export var TextNavTextOnDarkSelected = '#ffffff';
export var TextNavTextOnDarkFocus = '#ffffff';
export var TextNavTextOnLight = '#ffffff';
export var TextNavTextOnLightHover = '#ffffff';
export var TextNavTextOnLightSelected = '#ffffff';
export var TextNavTextOnLightFocus = '#ffffff';
export var TextTextErrorOnLight = '#D5324E';
export var TextCtaLinkSecondary = '#6F6F6F';
export var TextCtaLinkSecondaryPressed = '#6F6F6F';
export var TextCtaLinkSecondaryHover = '#6F6F6F';
export var TextCtaPromo = '#4826c2';
export var TextCtaLinkDisabled = '#b2cff2';
export var TextTextOnLightDisabled = '#bcbcbc';
export var TextToggletextText = '#004EAA';
export var TextTextDestructiveOnLight = '#D5324E';
export var OverlaySidepanelOverlay = 'rgba(0,0,0,0.5)';
export var OverlayModalOverlay = 'rgba(0,0,0,0.8)';
export var BrandBoxPrimary = '#0061d5';
export var BrandBoxSecondary = '#ccdff7';
export var BrandBoxTertiary = '#e5effa';
export var BrandFormsPrimary = '#1e9b67';
export var BrandFormsSecondary = '#d4f3e6';
export var BrandFormsTertiary = '#e9f8f2';
export var BrandDocgenPrimary = '#3a1e9b';
export var BrandDocgenSecondary = '#dad4f3';
export var BrandDocgenTertiary = '#ece9f8';
export var BrandSignPrimary = '#003c84';
export var BrandSignSecondary = '#ccd8e6';
export var BrandSignTertiary = '#e5ebf2';
export var BrandBoxAi100 = 'linear-gradient(135deg, #FE03DC 0%, #2784FA 100%)';
export var BrandBoxAi120 = 'linear-gradient(135deg, #CB02B0 0%, #1F6AC8 100%)';
export var BrandBoxAi140 = 'linear-gradient(135deg, #980284 0%, #174F96 100%)';
export var Gray10 = '#e8e8e8';
export var Gray20 = '#d3d3d3';
export var Gray30 = '#bcbcbc';
export var Gray40 = '#a7a7a7';
export var Gray50 = '#909090';
export var Gray65 = '#6F6F6F';
export var Gray80 = '#4e4e4e';
export var Gray90 = '#383838';
export var Gray100 = '#222222';
export var Gray02 = '#fbfbfb';
export var Gray05 = '#f4f4f4';
export var GrayBlack = '#000000';
export var GrayWhite = '#ffffff';
export var BoxBlue10 = '#e5effa';
export var BoxBlue20 = '#ccdff7';
export var BoxBlue30 = '#b2cff2';
export var BoxBlue40 = '#99c0ee';
export var BoxBlue50 = '#7fb0ea';
export var BoxBlue80 = '#3381dd';
export var BoxBlue100 = '#0061d5';
export var BoxBlue110 = '#0057C0';
export var BoxBlue120 = '#004EAA';
export var BoxBlue150 = '#00316B';
export var BoxBlue160 = '#002755';
export var BoxBlue170 = '#001D40';
export var BoxBlue180 = '#00132B';
export var BoxBlue05 = '#f2f7fd';
export var BoxBlue02 = '#fafcfe';
export var DarkBlue10 = '#e5ebf2';
export var DarkBlue20 = '#ccd8e6';
export var DarkBlue50 = '#7f9dc1';
export var DarkBlue100 = '#003c84';
export var DarkBlue110 = '#003677';
export var DarkBlue120 = '#00306a';
export var DarkBlue150 = '#001e42';
export var DarkBlue160 = '#001835';
export var DarkBlue170 = '#001228';
export var DarkBlue180 = '#000c1a';
export var DarkBlue05 = '#f2f5f9';
export var DarkBlue02 = '#fafbfd';
export var LightBlue10 = '#e9f2fe';
export var LightBlue20 = '#d3e7fe';
export var LightBlue50 = '#91c2fd';
export var LightBlue100 = '#2486fc';
export var LightBlue110 = '#2079E3';
export var LightBlue120 = '#1d6bca';
export var LightBlue150 = '#12437e';
export var LightBlue160 = '#0e3665';
export var LightBlue170 = '#0b284c';
export var LightBlue180 = '#071b32';
export var LightBlue05 = '#f4f9ff';
export var LightBlue02 = '#fbfdff';
export var GreenLight10 = '#e9f8f2';
export var GreenLight20 = '#d4f3e6';
export var GreenLight50 = '#92e0c0';
export var GreenLight100 = '#26c281';
export var GreenLight110 = '#22AF74';
export var GreenLight120 = '#1e9b67';
export var GreenLight150 = '#136140';
export var GreenLight160 = '#0f4e34';
export var GreenLight170 = '#0b3a27';
export var GreenLight180 = '#08271a';
export var GreenLight05 = '#f4fcf8';
export var GreenLight02 = '#fbfefd';
export var WatermelonRed10 = '#fdebee';
export var WatermelonRed20 = '#fbd7dd';
export var WatermelonRed50 = '#f69bab';
export var WatermelonRed100 = '#ed3757';
export var WatermelonRed110 = '#D5324E';
export var WatermelonRed120 = '#be2c46';
export var WatermelonRed150 = '#761b2b';
export var WatermelonRed160 = '#5f1623';
export var WatermelonRed170 = '#47101a';
export var WatermelonRed180 = '#2f0b11';
export var WatermelonRed05 = '#fef5f6';
export var WatermelonRed02 = '#fffbfc';
export var Orange10 = '#fdf2e8';
export var Orange20 = '#fce6d1';
export var Orange50 = '#f8c08c';
export var Orange100 = '#f1811a';
export var Orange110 = '#D97417';
export var Orange120 = '#c16715';
export var Orange150 = '#78400d';
export var Orange160 = '#60340a';
export var Orange170 = '#482708';
export var Orange180 = '#301a05';
export var Orange05 = '#fef8f3';
export var Orange02 = '#fffdfb';
export var Yellorange10 = '#fef7e8';
export var Yellorange20 = '#fdf0d1';
export var Yellorange50 = '#fad98d';
export var Yellorange100 = '#f5b31b';
export var Yellorange110 = '#DCA118';
export var Yellorange120 = '#c48f16';
export var Yellorange150 = '#7a590d';
export var Yellorange160 = '#62480b';
export var Yellorange170 = '#493608';
export var Yellorange180 = '#312405';
export var Yellorange05 = '#fefbf3';
export var Yellorange02 = '#fffefb';
export var Yellow10 = '#fffbe5';
export var Yellow20 = '#fff7cc';
export var Yellow50 = '#ffeb7f';
export var Yellow100 = '#ffd700';
export var Yellow110 = '#E6C100';
export var Yellow120 = '#ccac00';
export var Yellow150 = '#806b00';
export var Yellow160 = '#665600';
export var Yellow170 = '#4c4000';
export var Yellow180 = '#332b00';
export var Yellow05 = '#fffdf2';
export var Yellow02 = '#fffefa';
export var PurpleRain10 = '#f5ebfd';
export var PurpleRain20 = '#ecd9fb';
export var PurpleRain50 = '#cf9ff6';
export var PurpleRain100 = '#9f3fed';
export var PurpleRain110 = '#8F39D5';
export var PurpleRain120 = '#7f32be';
export var PurpleRain150 = '#4f1f76';
export var PurpleRain160 = '#40195f';
export var PurpleRain170 = '#301347';
export var PurpleRain180 = '#200d2f';
export var PurpleRain05 = '#faf5fe';
export var PurpleRain02 = '#fdfbff';
export var Grimace10 = '#ece9f8';
export var Grimace20 = '#dad4f3';
export var Grimace50 = '#a392e0';
export var Grimace100 = '#4826c2';
export var Grimace110 = '#4122AF';
export var Grimace120 = '#3a1e9b';
export var Grimace150 = '#241361';
export var Grimace160 = '#1d0f4e';
export var Grimace170 = '#160b3a';
export var Grimace180 = '#0e0827';
export var Grimace05 = '#f6f4fc';
export var Grimace02 = '#fbfbfe';
export var TitleSubtitleFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var TitleSubtitleFontWeight = 700;
export var TitleSubtitleLineHeight = '1.25rem';
export var TitleSubtitleFontSize = '0.875rem';
export var TitleSubtitleLetterSpacing = '0.01875rem';
export var TitleSubtitleParagraphSpacing = '0rem';
export var TitleSubtitleTextCase = 'none';
export var TitleSubtitleTextDecoration = 'none';
export var TitleSmallFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var TitleSmallFontWeight = 700;
export var TitleSmallLineHeight = '1.25rem';
export var TitleSmallFontSize = '0.9375rem';
export var TitleSmallLetterSpacing = '0.01875rem';
export var TitleSmallParagraphSpacing = '0rem';
export var TitleSmallTextCase = 'none';
export var TitleSmallTextDecoration = 'none';
export var TitleMediumFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var TitleMediumFontWeight = 700;
export var TitleMediumLineHeight = '1.5rem';
export var TitleMediumFontSize = '1rem';
export var TitleMediumLetterSpacing = '0.01875rem';
export var TitleMediumParagraphSpacing = '0rem';
export var TitleMediumTextCase = 'none';
export var TitleMediumTextDecoration = 'none';
export var TitleLargeFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var TitleLargeFontWeight = 700;
export var TitleLargeLineHeight = '1.5rem';
export var TitleLargeFontSize = '1.125rem';
export var TitleLargeLetterSpacing = '0.01875rem';
export var TitleLargeParagraphSpacing = '0rem';
export var TitleLargeTextCase = 'none';
export var TitleLargeTextDecoration = 'none';
export var TitleXLargeFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var TitleXLargeFontWeight = 700;
export var TitleXLargeLineHeight = '2rem';
export var TitleXLargeFontSize = '1.3125rem';
export var TitleXLargeLetterSpacing = '0.01875rem';
export var TitleXLargeParagraphSpacing = '0rem';
export var TitleXLargeTextCase = 'none';
export var TitleXLargeTextDecoration = 'none';
export var TitleMondoFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var TitleMondoFontWeight = 900;
export var TitleMondoLineHeight = '2.75rem';
export var TitleMondoFontSize = '2.25rem';
export var TitleMondoLetterSpacing = '0rem';
export var TitleMondoParagraphSpacing = '0rem';
export var TitleMondoTextCase = 'none';
export var TitleMondoTextDecoration = 'none';
export var BodyLargeFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var BodyLargeFontWeight = 400;
export var BodyLargeLineHeight = '1.5rem';
export var BodyLargeFontSize = '1rem';
export var BodyLargeLetterSpacing = '0.01875rem';
export var BodyLargeParagraphSpacing = '0rem';
export var BodyLargeTextCase = 'none';
export var BodyLargeTextDecoration = 'none';
export var BodyLargeBoldFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var BodyLargeBoldFontWeight = 700;
export var BodyLargeBoldLineHeight = '1.5rem';
export var BodyLargeBoldFontSize = '1rem';
export var BodyLargeBoldLetterSpacing = '0.01875rem';
export var BodyLargeBoldParagraphSpacing = '0rem';
export var BodyLargeBoldTextCase = 'none';
export var BodyLargeBoldTextDecoration = 'none';
export var BodyDefaultBoldFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var BodyDefaultBoldFontWeight = 700;
export var BodyDefaultBoldLineHeight = '1.25rem';
export var BodyDefaultBoldFontSize = '0.875rem';
export var BodyDefaultBoldLetterSpacing = '0.01875rem';
export var BodyDefaultBoldParagraphSpacing = '0rem';
export var BodyDefaultBoldTextCase = 'none';
export var BodyDefaultBoldTextDecoration = 'none';
export var BodyDefaultSemiboldFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var BodyDefaultSemiboldFontWeight = 600;
export var BodyDefaultSemiboldLineHeight = '1.25rem';
export var BodyDefaultSemiboldFontSize = '0.875rem';
export var BodyDefaultSemiboldLetterSpacing = '0.01875rem';
export var BodyDefaultSemiboldParagraphSpacing = '0rem';
export var BodyDefaultSemiboldTextCase = 'none';
export var BodyDefaultSemiboldTextDecoration = 'none';
export var BodyDefaultFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var BodyDefaultFontWeight = 400;
export var BodyDefaultLineHeight = '1.25rem';
export var BodyDefaultFontSize = '0.875rem';
export var BodyDefaultLetterSpacing = '0.01875rem';
export var BodyDefaultParagraphSpacing = '0rem';
export var BodyDefaultTextCase = 'none';
export var BodyDefaultTextDecoration = 'none';
export var CaptionBoldFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var CaptionBoldFontWeight = 700;
export var CaptionBoldLineHeight = '0.875rem';
export var CaptionBoldFontSize = '0.75rem';
export var CaptionBoldLetterSpacing = '0.01875rem';
export var CaptionBoldParagraphSpacing = '0rem';
export var CaptionBoldTextCase = 'none';
export var CaptionBoldTextDecoration = 'none';
export var CaptionDefaultFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var CaptionDefaultFontWeight = 400;
export var CaptionDefaultLineHeight = '0.875rem';
export var CaptionDefaultFontSize = '0.75rem';
export var CaptionDefaultLetterSpacing = '0.01875rem';
export var CaptionDefaultParagraphSpacing = '0rem';
export var CaptionDefaultTextCase = 'none';
export var CaptionDefaultTextDecoration = 'none';
export var LabelBoldFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var LabelBoldFontWeight = 700;
export var LabelBoldLineHeight = '1rem';
export var LabelBoldFontSize = '0.625rem';
export var LabelBoldLetterSpacing = '0.0375rem';
export var LabelBoldParagraphSpacing = '0rem';
export var LabelBoldTextCase = 'none';
export var LabelBoldTextDecoration = 'none';
export var LabelDefaultFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var LabelDefaultFontWeight = 400;
export var LabelDefaultLineHeight = '1rem';
export var LabelDefaultFontSize = '0.625rem';
export var LabelDefaultLetterSpacing = '0.0375rem';
export var LabelDefaultParagraphSpacing = '0rem';
export var LabelDefaultTextCase = 'none';
export var LabelDefaultTextDecoration = 'none';
export var LinkDefaultFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var LinkDefaultFontWeight = 400;
export var LinkDefaultLineHeight = '1.25rem';
export var LinkDefaultFontSize = '0.875rem';
export var LinkDefaultLetterSpacing = '0.01875rem';
export var LinkDefaultParagraphSpacing = '0rem';
export var LinkDefaultParagraphIndent = '0rem';
export var LinkDefaultTextCase = 'none';
export var LinkDefaultTextDecoration = 'underline';
export var Radius05 = '0.125rem';
export var Radius1 = '0.25rem';
export var Radius2 = '0.375rem';
export var Radius3 = '0.5rem';
export var Radius4 = '0.75rem';
export var Radius5 = '1rem';
export var Radius6 = '1.25rem';
export var Radius7 = '1.5rem';
export var Radius8 = '1.75rem';
export var RadiusHalf = '2rem';
export var Border1 = '0.0625rem';
export var Border2 = '0.125rem';
export var Border3 = '0.1875rem';
export var Space05 = '0.125rem';
export var Space1 = '0.25rem';
export var Space2 = '0.5rem';
export var Space3 = '0.75rem';
export var Space4 = '1rem';
export var Space5 = '1.25rem';
export var Space6 = '1.5rem';
export var Space7 = '1.75rem';
export var Space8 = '2rem';
export var Space9 = '2.25rem';
export var Space10 = '2.5rem';
export var Space11 = '2.75rem';
export var Space12 = '3rem';
export var Space14 = '3.5rem';
export var Space15 = '3.75rem';
export var Space16 = '4rem';
export var Space18 = '4.5rem';
export var Space20 = '5rem';
export var Dropshadow3 = {
  x: '0rem',
  y: '0.25rem',
  blur: '0.75rem',
  spread: '0rem',
  color: 'rgba(0,0,0,0.1)',
  type: 'dropShadow'
};
export var Dropshadow3Inverse = {
  x: '0rem',
  y: '-0.25rem',
  blur: '0.75rem',
  spread: '0rem',
  color: 'rgba(0,0,0,0.1)',
  type: 'dropShadow'
};
export var Dropshadow2 = {
  x: '0rem',
  y: '0.0625rem',
  blur: '0.25rem',
  spread: '0rem',
  color: 'rgba(0,0,0,0.1)',
  type: 'dropShadow'
};
export var Dropshadow1 = {
  x: '0rem',
  y: '0rem',
  blur: '0.5rem',
  spread: '0rem',
  color: 'rgba(0,0,0,0.05)',
  type: 'dropShadow'
};
export var Innershadow1 = {
  x: '0rem',
  y: '0.125rem',
  blur: '0.25rem',
  spread: '0rem',
  color: 'rgba(0,0,0,0.1)',
  type: 'innerShadow'
};
export var BlackOpacity80 = 'rgba(0,0,0,0.8)';
export var BlackOpacity60 = 'rgba(0,0,0,0.6)';
export var BlackOpacity50 = 'rgba(0,0,0,0.5)';
export var BlackOpacity08 = 'rgba(0,0,0,0.08)';
export var BlackOpacity04 = 'rgba(0,0,0,0.04)';
export var BlackOpacity00 = 'rgba(0,0,0,0)';
export var Size05 = '0.125rem';
export var Size1 = '0.25rem';
export var Size2 = '0.5rem';
export var Size3 = '0.75rem';
export var Size4 = '1rem';
export var Size5 = '1.25rem';
export var Size6 = '1.5rem';
export var Size7 = '1.75rem';
export var Size8 = '2rem';
export var Size9 = '2.25rem';
export var Size10 = '2.5rem';
export var Size11 = '2.75rem';
export var Size12 = '3rem';
export var Size14 = '3.5rem';
export var Size15 = '3.75rem';
export var Size16 = '4rem';
export var Size18 = '4.5rem';
export var Size20 = '5rem';
export var WhiteOpacity70 = '#ffffffb3';
export var WhiteOpacity30 = '#ffffff4d';
export var Border4 = '0.25rem';
export var Border6 = '0.375rem';
export var Border8 = '0.5rem';
export var FontFamiliesSans = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var FontWeightsRegular = 400;
export var FontWeightsSemibold = 600;
export var FontWeightsBold = 700;
export var FontWeightsBlack = 900;
export var TextDecorationUnderline = 'underline';
export var AnimationDuration2 = '200ms';
export var AnimationDuration3 = '300ms';
export var AnimationDuration4 = '400ms';
export var AnimationEasingEaseBase = 'cubic-bezier(0.16, 1, 0.3, 1)';
export var MotionTransitionSlideIn = '400ms cubic-bezier(0.16, 1, 0.3, 1)';
export var BreakpointSmall = '374px';
export var BreakpointMedium = '767px';
export var BreakpointLarge = '1023px';
export var BreakpointXlarge = '1219px';
export var NotificationDefaultFontFamily = "Lato, -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export var NotificationDefaultFontWeight = 700;
export var NotificationDefaultLineHeight = '0.75rem';
export var NotificationDefaultFontSize = '0.5625rem';
export var NotificationDefaultLetterSpacing = '0.01875rem';
export var NotificationDefaultTextDecoration = 'none';
export var NotificationDefaultTextCase = 'none';
export var NotificationDefaultParagraphSpacing = '0rem';
export var NotificationDefaultParagraphIndent = '0rem';